import timePickerView from './timePickerComponent.html';
import './timePickerComponent.css';
import _ from 'lodash';

export function timePickerComponent() {
	return {
		bindings: {
			model: '=',
			step: '<?',
		},
		controllerAs: 'vm',
		controller: timePickerComponentCtrl,
		template: timePickerView,
	};
}

const zeropad = n => _.padLeft(n, 2, '0');

export class timePickerComponentCtrl {
	constructor($scope) {
		'ngInject';
		// save injections
		this.$scope = $scope;
		// self bind some functions
		this.setupSelects = this.setupSelects.bind(this);
		this.updateValues = this.updateValues.bind(this);
	}

	// bindings are available
	$onInit() {
		this.setupSelects();
		this.updateValues();
		this.$scope.$watch('vm.model', this.updateValues);
		this.$scope.$watch('vm.step', this.setupSelects);
	}

	// step has updated; update select
	setupSelects() {
		this.step = this.step || 15;
		this.hourChoices = _.range(1, 13).map(n => ({ id: n, name: n }));
		this.minuteChoices = _.range(0, 60, this.step).map(n => ({ id: n, name: zeropad(n) }));
		this.meridianChoices = ['am', 'pm'].map(n => ({ id: n, name: n }));
		this.updateValues();
	}

	// model has updated; update select
	updateValues() {
		if (this.fromUserChange) {
			// model changed in this.onSelectChange
			this.fromUserChange = false;
			return;
		}
		const hms = (this.model || '').trim();
		// 24h time such as "21:00:00" or "21:00" or "050000" or "500"
		const match24 = hms.match(/^([01]?\d|2[0-3]):?([0-5][0-9])(:?[0-5][0-9])?$/i);
		// 12h time such as "09:30:00 am" or "09:30am" or "0930am" or "930am"
		const match12 = hms.match(/^([01]?\d|1[0-2]):?([0-5][0-9])(:?[0-5][0-9])?\s*(am|pm)$/i);
		let hour, minute, meridian;
		if (match24) {
			// 24 hour format
			hour = parseFloat(match24[1]) || 12;
			minute = parseFloat(match24[2]);
			if (hour < 12) {
				meridian = 'am';
			} else if (hour == 12) {
				meridian = 'pm';
			} else {
				meridian = 'pm';
				hour -= 12;
			}
		} else if (match12) {
			// 12 hour format
			hour = parseFloat(match12[1]) || 12;
			minute = parseFloat(match12[2]);
			meridian = match12[4];
		} else {
			// model value didn't make sense
			hour = 8;
			minute = 0;
			meridian = 'am';
		}
		// round minute down to the nearest minute step
		const remainder = minute % this.step;
		if (remainder) {
			minute -= remainder;
		}
		// set values for view
		this.hour = hour;
		this.minute = minute;
		this.meridian = meridian;
	}

	// select has changed; update model
	onSelectChange() {
		let hour = this.hour;
		const min = this.minute;
		if (this.meridian == 'am' && hour === 12) {
			hour = 0;
		} else if (this.meridian == 'pm' && hour < 12) {
			hour += 12;
		}
		this.model = zeropad(hour) + ':' + zeropad(min) + ':00';
		this.fromUserChange = true;
	}
}
